import React from "react";
import MaterialButton from "@mui/material/Button";
import { Box, Typography, Breadcrumbs } from "@mui/material";
import { useParams } from "react-router-dom";
import { useKeycloak } from "@react-keycloak/web";
import UserDetailsCard from "./UserDetailsCard";
import UserDetailsTable from "./UserDetailsTable";
import Loader from "../../common/Loader";
import { useUserDetailsSA } from "../../../../tanstackQuery/queries/superAdmin/org";
import { useLocation, useNavigate } from "react-router-dom";
import { useAtom } from "jotai";
import { SAdminBaseAtom } from "../../../../stores/jotai/super-admin/superAdminBase";
import { useQueryClient } from "@tanstack/react-query";
import { findParent } from "../../../../stores/jotai/base";

const UserDetails = () => {
  const { userId } = useParams();
  const { keycloak } = useKeycloak();
  const location = useLocation();
  const navigate = useNavigate();
  const [sAdminBase,]=useAtom(SAdminBaseAtom);
  const orgID = sAdminBase?.selectedOrg.orgID
  const orgName = sAdminBase?.selectedOrg?.name;
  const teamName = sAdminBase?.selectedGroup?.group?.name
  const cohortName =  sAdminBase?.selectedCohort?.group?.name
  const passedUserData = location.state?.userData;
    const client = useQueryClient();
  
  const orgTreeData = client.getQueryData([
    "orgtree",
    { orgID: sAdminBase?.selectedOrg?.orgID }
  ]) as any;
  const folderName =orgTreeData?.hierarchy? findParent(sAdminBase?.selectedCohort?.childID,orgTreeData?.hierarchy):null;
  const { data: userData, isLoading: isUserLoading } = useUserDetailsSA(
    { accessToken: keycloak?.token },
    { userID:userId },
    { enabled: !!keycloak?.token && !!userId }
  );

  React.useEffect(() => {
    if (!passedUserData) {
      navigate("/admin", { replace: true });
    }
  }, [navigate]);

  return (
    <Box mx={3} mt={3}>
      <Typography variant="h5" sx={{ fontWeight: "bold", paddingLeft: "6px" }}>
        User Details: {passedUserData?.name}
      </Typography>
      <Box style={{ paddingLeft: 6 }}>
        <Breadcrumbs
          aria-label="breadcrumb"
          sx={{ backgroundColor: "#f4f4f4" }}
        >
          <Typography color="inherit">{orgName}</Typography>
          {folderName?.group?.name && (
            <Typography color="inherit">{folderName?.group?.name}</Typography>
          )}
          {cohortName && <Typography color="inherit">{cohortName}</Typography>}
          {teamName && <Typography color="inherit">{teamName}</Typography>}
        </Breadcrumbs>
        <Box style={{ paddingTop: 10 }}>
          <MaterialButton variant="contained" onClick={() => navigate(-1)}>
            Return
          </MaterialButton>
        </Box>
      </Box>
      <UserDetailsCard userDetails={passedUserData} />
      {
        isUserLoading ?  <Loader /> : <UserDetailsTable userDetails={passedUserData} usersOrg={userData} />
      }
    </Box>
  );
};

export default UserDetails;
